import Vue from 'vue'
import Toasted from 'vue-toasted'
import store from '../../vue/store'
import clientLocaleBundle from './locales'
import clientConfigurationBundle from './config'
import AdvProductCard from './AdvProductCard.vue'
import AdvProductPageCard from './AdvProductPageCard.vue'
import config from '../../vue/config/configPlugin'
import locale from '../../vue/locales/localePlugin'
import AdvCartGiftList from './AdvCartGiftList'
import AdvButtonViewBuy from './AdvButtonViewBuy'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
import AdvCartProductList from './AdvCartProductList.vue'
import InitialData from '../../vue/data-components/InitialData.vue'
import AdvMinicartGiftChoiceModal from './AdvMinicartGiftChoiceModal'
import LiveProductData from '../../vue/data-components/LiveProductData.vue'
import jqueryVueBridgePlugin from '../../vue/plugins/jqueryVueBridgePlugin'
import AdvHtmlPicture from '../../vue/components/AdvHtmlPicture'
import CookieModal from './cookies/components/CookieModal.vue'
import CookieSettingsButton from './cookies/components/CookieSettingsButton.vue'
import AdvCartProductCustomizationEditor from './cartProductCustomizations/AdvCartProductCustomizationEditor'
import AdvCartProductCustomizationDisplayValues
from './cartProductCustomizations/AdvCartProductCustomizationDisplayValues.vue'
import AfterAddToCartModal from './AfterAddToCartModal.vue'
import ProductPriceChartModal from './product/ProductPriceChartModal.vue'
import FlipbookModal from './FlipbookModal.vue'
import PreCheckoutSidebar from './PreCheckoutSidebar.vue'
import ViberForm from './ViberForm.vue'
import ViberSignOut from './ViberSignOut.vue'
import BirthdayForm from './BirthdayForm'
import AdvProductPageSignature from './AdvProductPageSignature.vue'
import AdvDioptraProductTabs from './AdvDioptraProductTabs.vue'
import DioptraModalProductCard from './DioptraModalProductCard.vue'
import FlipBookAddToCartBtn from './FlipBookAddToCartBtn.vue'
import NewsletterForm from './NewsletterForm.vue'

const CheckoutPage = () => import(/* webpackChunkName: "checkout-page" */ './CheckoutPage.vue')
const CheckoutPageDioptra = () => import(/* webpackChunkName: "checkout-page-dioptra" */ './CheckoutPageDioptra.vue')
const googleMapPartners = () => import(/* webpackChunkName: "google-map-partners" */ './googleMaps/components/googleMapPartners.vue')
const AllListingFilters = () => import(/* webpackChunkName: "all-listing-filters" */ './AllListingFilters.vue')
const AdvListingUsedFilters = () => import(/* webpackChunkName: "adv-listing-used-filters" */ './AdvListingUsedFilters.vue')

const AdvCurrentFilters = () => import(/* webpackChunkName: "adv-current-filters" */ './AdvCurrentFilters.vue')
const AdvButtonViewBuyCombo = () => import(/* webpackChunkName: "adv-button-view-buy-combo" */ './AdvButtonViewBuyCombo.vue')
const AdvProductGallery = () => import(/* webpackChunkName: "adv-product-gallery" */ './AdvProductGallery.vue')
const AdvProductGalleryMobile = () => import(/* webpackChunkName: "adv-product-gallery-mobile" */ './AdvProductGalleryMobile.vue')
const GiftCardPage = () => import(/* webpackChunkName: "gift-card-page" */ './giftCards/GiftCardPage.vue')
const Lottie = () => import(/* webpackChunkName: "lottie" */ './Lottie.vue')

const AccountDeletion = () => import(/* webpackChunkName: "account-deletion" */ './AccountDeletion.vue')

Vue.use(Toasted, { iconPack: 'fontawesome' })
Vue.use(VueTinyLazyloadImg)
Vue.use(config, { clientConfigurationBundle: clientConfigurationBundle })
Vue.use(locale, { clientLocaleBundle: clientLocaleBundle })
Vue.use(jqueryVueBridgePlugin)

window.Vue = new Vue({
  el: '#app',
  store,
  config,
  locale,
  jqueryVueBridgePlugin,
  components: {
    InitialData,
    LiveProductData,
    CookieModal,
    CookieSettingsButton,
    AdvProductCard,
    AdvProductPageCard,
    FlipBookAddToCartBtn,
    AdvDioptraProductTabs,
    AdvProductPageSignature,
    AdvButtonViewBuy,
    AdvCartProductList,
    AdvCartGiftList,
    AdvMinicartGiftChoiceModal,
    AdvHtmlPicture,
    AdvCartProductCustomizationEditor,
    AdvCartProductCustomizationDisplayValues,
    AfterAddToCartModal,
    ProductPriceChartModal,
    FlipbookModal,
    PreCheckoutSidebar,
    AdvProductGallery,
    AdvProductGalleryMobile,
    AdvButtonViewBuyCombo,
    AdvListingUsedFilters,
    AdvCurrentFilters,
    AllListingFilters,
    CheckoutPage,
    CheckoutPageDioptra,
    googleMapPartners,
    GiftCardPage,
    AccountDeletion,
    Lottie,
    ViberForm,
    ViberSignOut,
    BirthdayForm,
    DioptraModalProductCard,
    NewsletterForm
  },
  computed: {
    countCartProducts () {
      return store.getters.cartProductsCount
    },
    countCartProductPieces () {
      return store.getters.cartProductPiecesCount
    },
    cartHasProduct () {
      return !store.getters.cartEmpty
    },
    cartTotal () {
      return store.getters.cartProductsTotal.toFixed(2)
    },
    productCardModal () {
      return store.getters.productCardModal
    },
    cartProductWeightTotal () {
      return store.getters.cartProductWeightTotal
    },
    cartDefaultCouponCode () {
      return store.getters.getDefaultCouponCode
    },
    cartDefaultCouponDiscount () {
      return parseFloat(store.getters.getDefaultCouponDiscount).toFixed(2)
    },
    cartDefaultCouponName () {
      return store.getters.getDefaultCouponName
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    closeProductCardModal () {
      store.dispatch('closeProductCardModal')
    },
    checkConnectionStatus () {
      store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  },
  watch: {
    cartHasProduct(val) {
      // To remove initial cart empty row `d-none` in case there are no products in the cart
      if (!val) {
        const cartEmptyRow = document.getElementById('cartEmptyRow')
        if (cartEmptyRow && cartEmptyRow.classList.contains('d-none')) {
          cartEmptyRow.classList.remove('d-none')
        }
      }
    }
  }
})
